var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomersV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6662 12.4996C10.6662 11.2032 10.1512 9.95981 9.23449 9.04308C8.31776 8.12634 7.0744 7.61133 5.77795 7.61133C4.48149 7.61133 3.23813 8.12634 2.3214 9.04308C1.40466 9.95981 0.889648 11.2032 0.889648 12.4996",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77784 7.61037C7.46517 7.61037 8.83303 6.24252 8.83303 4.55519C8.83303 2.86785 7.46517 1.5 5.77784 1.5C4.09051 1.5 2.72266 2.86785 2.72266 4.55519C2.72266 6.24252 4.09051 7.61037 5.77784 7.61037Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1097 11.8876C13.1097 9.82844 11.8877 7.9159 10.6656 6.99934C11.0673 6.69796 11.3885 6.3022 11.6008 5.84709C11.8131 5.39198 11.91 4.89155 11.8828 4.39009C11.8556 3.88863 11.7052 3.40161 11.445 2.97212C11.1847 2.54263 10.8226 2.18392 10.3906 1.92773",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersV2);
export default __webpack_public_path__ + "static/media/customersV2.6e421da0f6c5e9e500a77f804a5ac610.svg";
export { ForwardRef as ReactComponent };